import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmationDialog from '../../../yoda-ui/components/Dialogs/ConfirmationDialog';
import Loader from '../../../yoda-ui/components/Loader';
import { YodaColors } from '../../../yoda-ui/yodaTheme';
import useCepAdminDashboardList from './CepAdminDashboardList.hook';
import { CountWidgetPropsType } from 'components/CountWidgets/CountWidget.types';
import GridList from 'components/GridList/GridList';

const CepAdminDashboardList: FC<CountWidgetPropsType> = ({ filters, useAdminFilters }) => {
  const {
    cepListColumnConfig,
    getFilteredRows,
    cepLoading,
    onPageChange,
    onPageSizeChange,
    rowCountState,
    open,
    confirmationDialogConfig,
    removeCepLoading,
    cancelCepLoading,
    restoreCepLoading,
    setOpen,
  } = useCepAdminDashboardList(filters, useAdminFilters);

  const { t } = useTranslation();

  return (
    <>
      <GridList
        loading={ cepLoading }
        getRowId={ (row) => row._id }
        columnConfig={ cepListColumnConfig }
        rows={ getFilteredRows() }
        onPageChange={ onPageChange }
        onPageSizeChange={ onPageSizeChange }
        rowCountState={ rowCountState }
        disableColumnMenu={ true }
        isOnDashboard={ true }
      />
      {
        open && (
          <ConfirmationDialog
            { ...confirmationDialogConfig }
            onConfirmLabel={
              removeCepLoading || cancelCepLoading || restoreCepLoading
                ? <Loader center size={ 1 } color={ YodaColors.inherit } /> : t('actions_confirm_label')
            }
            onDismiss={ () => setOpen(false) }
            onDismissLabel={ t('actions_cancel_label') }
          >
          </ConfirmationDialog>
        )
      }
    </>
  );
};

export default CepAdminDashboardList;
